/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AssignPatientDialog.vue?vue&type=template&id=216e97ed"
import script from "./AssignPatientDialog.vue?vue&type=script&lang=js"
export * from "./AssignPatientDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignPatientDialog.vue?vue&type=style&index=0&id=216e97ed&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('216e97ed')) {
      api.createRecord('216e97ed', component.options)
    } else {
      api.reload('216e97ed', component.options)
    }
    module.hot.accept("./AssignPatientDialog.vue?vue&type=template&id=216e97ed", function () {
      api.rerender('216e97ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/AssignPatientDialog.vue"
export default component.exports